import React from 'react';

const CardLabel = ({ text, className, children }) => (
	<div className={className}>
		{children || <p> {text} </p>}
	</div>
);

export default CardLabel;
